import * as React from 'react';
import _ from 'lodash';
function downloadFile(data, fileName) {
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.style = 'display: none';
  const blob = new Blob([data], {
      type: 'octet/stream'
    }),
    url = window.URL.createObjectURL(blob);
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
}
async function downloadFromUrl(url, fileName) {
  try {
    const file = await fetch(url, {
      'Sec-Fetch-Site': 'cross-site',
      'Sec-Fetch-Mode': 'no-cors',
      Accept: '*'
    });
    const fileBlob = await file.blob();
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.style = 'display: none';
    url = window.URL.createObjectURL(fileBlob);
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  } catch (e) {
    console.log('failed to fetch');
  }
}

// Function to print strings present
// between any pair of delimeters
function getSubsInDelimeters(str, startDelimiter = '', endDelimiter = '') {
  // validate if str is a string
  if (typeof str !== 'string') return ['Chu#$% string ni pass kari'];
  if (startDelimiter.length > 1) return ['startDelimiter can only be 1 character'];
  if (endDelimiter.length > 1) return ['endDelimiter can only be 1 character'];

  //  array of resulted strings
  let result = [];

  // Stores the indices of
  let dels = [];
  for (let i = 0; i < str.length; i++) {
    // If opening delimeter
    // is encountered
    if (str[i] === startDelimiter) {
      dels.push(i);
    }

    // If closing delimeter
    // is encountered
    else if (str[i] === endDelimiter && dels.length > 0) {
      // Extract the position
      // of opening delimeter
      let pos = dels[dels.length - 1];
      dels.pop();

      // Length of substring
      let len = i - 1 - pos;

      // Extract the substring
      let ans;
      if (pos < len) {
        ans = str.substring(pos + 1, len + 1);
      } else {
        ans = str.substring(pos + 1, len + pos + 1);
      }
      result.push(ans);
    }
  }
  let rest = str;
  result.forEach(subStr => {
    rest = rest.replaceAll(`[${subStr}]`, '');
  });
  return {
    result,
    rest
  };
}
function isValidJSON(string) {
  try {
    JSON.parse(string);
    return true;
  } catch (e) {
    return false;
  }
}
const isPrimitive = val => val !== Object(val);
const depsEqual = (obj, prevObj) => {
  return _.isEqual(obj, prevObj);
};
const updateRef = (ref, innerRef) => {
  if (!ref) return;
  if (typeof ref === 'function') {
    ref(innerRef.current);
  } else {
    // eslint-disable-next-line no-param-reassign
    ref.current = innerRef.current;
  }
};
const useForwardedRef = ref => {
  const innerRef = React.useRef(null);
  updateRef(ref, innerRef);
  React.useLayoutEffect(() => updateRef(ref, innerRef));
  React.useEffect(() => updateRef(ref, innerRef));
  return innerRef;
};
const checkUserAgent = () => {
  const IS_IPAD = navigator.userAgent.match(/iPad/i) !== null;
  const IS_IPHONE = !IS_IPAD && (navigator.userAgent.match(/iPhone/i) !== null || navigator.userAgent.match(/iPod/i) !== null);
  if (IS_IPAD || IS_IPHONE) return 'IOS';
  if (navigator.userAgent.match(/android/i) !== null) return 'ANDROID';
  return 'WEB';
};
const convertToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
  reader.onerror = error => reject(error);
});
const generateBase64File = async url => {
  try {
    const file = await fetch(url, {
      'Sec-Fetch-Site': 'cross-site',
      'Sec-Fetch-Mode': 'no-cors',
      Accept: '*'
    });
    const fileBlob = await file.blob();
    return await convertToBase64(fileBlob);
  } catch (e) {
    console.log('failed to fetch');
  }
};
const getValueAtPath = (obj, path) => {
  // const output = getValueAtPath(obj, '.nestedObjLevel1.nestedObjLevel2');
  // output will be: obj.nestedObjLevel1.nestedObjLevel2;
  let value = undefined;
  try {
    // eslint-disable-next-line no-new-func
    value = Function(`return function(obj){return obj${path}}`)()(obj);
  } catch (error) {
    console.log('Granite malformed object path ->', error);
  }
  return value;
};
export { downloadFile, getSubsInDelimeters, isValidJSON, downloadFromUrl, useForwardedRef, isPrimitive, depsEqual, checkUserAgent, convertToBase64, generateBase64File, getValueAtPath };